import { createMachine } from "@xstate/fsm";
const routerStateConfig = {
    id: "routerConn",
    initial: "connecting",
    states: {
        connecting: {
            on: {
                CONNECT: { target: "connected" },
                DISCONNECT: { target: "connecting" },
            },
        },
        connected: {
            on: {
                DISCONNECT: { target: "connecting" },
            },
        },
    },
};
export const routerConnState = createMachine(routerStateConfig);
//# sourceMappingURL=RouterConnectionStateMachine.js.map